module.exports = ".modal-body_popup {\r\n  position: relative;\r\n  padding: 2px!important;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/sharedcomponents/about-us/about-us.component.css
// module id = ./src/app/sharedcomponents/about-us/about-us.component.css
// module chunks = main